import { render, staticRenderFns } from "./CustomerCoordAdd.vue?vue&type=template&id=5852a48e"
import script from "./CustomerCoordAdd.vue?vue&type=script&lang=js"
export * from "./CustomerCoordAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports